import { render } from "./faqWrite.vue?vue&type=template&id=696228e9&scoped=true&ts=true"
import script from "./faqWrite.vue?vue&type=script&lang=ts&config=true"
export * from "./faqWrite.vue?vue&type=script&lang=ts&config=true"

import "./faqWrite.vue?vue&type=style&index=0&id=696228e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-696228e9"]])

export default __exports__